export enum AlertingTableSortPropertyStoreModelEnum {
  Site = 'site',
  Type = 'type',
  Subject = 'subject',
  State = 'state',
  Timestamp = 'timestamp',
  Severity = 'severity',
}
